import Event from '../../core/Event';
import { MonthEstimation } from '../../../domain/estimations/Estimations';

export default class EstimationsImportSucceed extends Event {
    public static type = 'EstimationsImportSucceed';

    constructor(public readonly rowsToImport: MonthEstimation[], public readonly errors: string[]) {
        super(EstimationsImportSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationsImportSucceed.ts